import { useEffect, useState } from "react";
import "./serviceCategoryItem.css";
import { services } from "../../barberData";
import { getServicePriceByLevel } from "../../models/employees";

export const ServiceCategoryItem = ({ serviceCategory }) => {
  const [aosAnimation, setAosAnimation] = useState("");

  useEffect(() => {
    const updateAosAnimation = () => {
      if (window.innerWidth <= 768) {
        setAosAnimation("fade-up");
      } else {
        setAosAnimation(
          serviceCategory.id % 2 === 0 ? "fade-right" : "fade-left",
        );
      }
    };

    updateAosAnimation();
    window.addEventListener("resize", updateAosAnimation);

    return () => window.removeEventListener("resize", updateAosAnimation);
  }, [serviceCategory.id]);

  let servicesFiltered = services.filter(
    (service) => service.categoryId === serviceCategory.id,
  );

  return (
    <div className="block" data-aos={aosAnimation} data-aos-duration="1800">
      <div className="serviceWrapper">
        <div className={serviceCategory.id % 2 === 1 ? "img" : "img"}>
          <img
            className="icon"
            src={require(`../../media/vector/${serviceCategory.icon}.png`)}
            alt=""
          />
        </div>
        <div className="desc">
          <h5>{serviceCategory.header}</h5>
          <ul>
            {servicesFiltered.map((service, index) => {
              const masterPrice = getServicePriceByLevel("master", service);
              const regularPrice = getServicePriceByLevel("regular", service);
              const juniorPrice = getServicePriceByLevel("junior", service);

            return (
              <li style={{listStyleType: "none"}} key={service.id}>
                <div className="serviceRow">
                  <span className="serviceName">{service.nazev}</span>
                  <span className="serviceDots"></span>
                  <span className="servicePrice">
                    <b style={{fontWeight: 500}} title={"Master"}>
                      {masterPrice},-
                      <b style={{fontSize: "2.2rem", fontWeight: 300, padding: "0 0.5rem", color: "#918f8f"}}>|</b> 
                    </b>
                    <b style={{fontWeight: 500}} title={"Regular"}>
                      {regularPrice},-
                      <b style={{fontSize: "2.2rem", fontWeight: 300, padding: "0 0.5rem", color: "#918f8f"}}>|</b> 
                    </b>
                    <b style={{fontWeight: 500}} title={"Junior"}>
                      {juniorPrice},-
                    </b>
                  </span>
                </div>
                {service.description && <p className="serviceDescription">{service.description}</p>}
                {/* Render a break after every third item only if category ID is 3 */}
                {(index + 1) % 3 === 0 && serviceCategory.id === 3 && <br />}
              </li>
            );
          })}
          </ul>
        </div>
      </div>
      {serviceCategory.id !== 5 && (
        <hr
          className={
            serviceCategory.id % 2 === 1 ? "thinHR rightContent" : "thinHR"
          }
        />
      )}
    </div>
  );
};
